import { C } from "@angular/core/src/render3";
import { MensagemErroModel } from "../../../shared/model/mensagem-erro.model";

export class DadosOnInitModelView{
  ListaValorMensalDistribuicaoRoyalty:ConsultaValorMensalDistribuicao[];

  objetoMensagem: MensagemErroModel;
}

export class CadastraValorMensalDistribuicaoFiltro{
  MesAno:string;
}

export class ConsultaValorMensalDistribuicao{
  SequencialValorMensalDistribuicao:number;
  DataReferenciaDistribuicao:string;
  DataReferenciaDistribuicaoFormatada:string;
  ValorMensalDistribuicao:number;
  CodigoServidorInclusao: string;
  CodigoServidorExternoInclusao: string;
  NumeroCPFBaseTerceiroInclusao: string;
  DigitoCPFBaseTerceiroInclusao:number;
  CodigoServidorAlteracao:string;
  CodigoServidorExternoAlteracao:string;
  NumeroCPFBaseTerceiroAlteracao:string;
  DigitoCPFBaseTerceiroAlteracao:number;
  DataInclusao:string;
  NomeUsuario:string
}

export class AlteraValorMensalDistribuicao{
  DataReferenciaDistribuicao:string;
  SequencialValorMensalDistribuicao:number;
  ValorMensalDistribuicao:number;
  LoginUsuario: string;
}

export class CadastraValorMensalDistribuicao{
  
  DataReferenciaDistribuicao:string;
  ValorMensalDistribuicao:number;
  LoginUsuario: string;
}

export class CadastraValorMensalDistribuicaoModelView{
  ListaCadastraValorMensal : CadastraValorMensalDistribuicao[];
  objetoMensagem: MensagemErroModel;
}



// WEBPACK FOOTER //
// ./src/app/royalts/shared/model/cadastra-valor-mensal-distribuir.model.ts